const TIME_STEP_MINUTES = 30;

export const BANNER_LOCATION_OPTIONS = [
  { label: 'Akcijos', value: 'deals', code: 701 },
  { label: 'Pagrindinis puslapis', value: 'home', code: 702 },
  { label: 'Meniu', value: 'menu', code: 703, disabled: true },
  { label: 'Apmokėjimuose', value: 'payments', code: 704, disabled: true },
];

export const BANNER_DEEPLINK_OPTIONS = [
  { name: 'Pasirinkti', value: '' },
  {
    name: 'Virtualios pildymas',
    value: 'https://h2auto.lt/buyVirtualMoney',
  },
  {
    name: 'Nuolaidų planai',
    value: 'https://h2auto.lt/membership',
  },
  {
    name: 'Kuponai',
    value: 'https://h2auto.lt/discount/',
  },
  {
    name: 'Lojalumo programa',
    value: 'https://h2auto.lt/loyalty',
  },
  {
    name: 'Pakviesk draugą',
    value: 'https://h2auto.lt/affiliates',
  },
];

const createTimeOptions = () => {
  const options = [{ name: 'Pasirinkti', value: '' }];

  for (let hour = 0; hour < 24; hour += 1) {
    for (let minute = 0; minute < 60; minute += TIME_STEP_MINUTES) {
      const value = `${String(hour).padStart(2, '0')}:${String(minute).padStart(
        2,
        '0'
      )}`;
      options.push({ name: value, value });
    }
  }

  options.push({ name: '23:59', value: '23:59' });

  return options;
};

export const BANNER_TIME_OPTIONS = createTimeOptions();
